module.exports = __webpack_public_path__ + "static/media/81MmoQHsq4L._AC_UY606_.a950b68f.jpg";